import AboutSection from '@/components/AboutSection';
import LogoMitra from '@/components/LogoMitra';
import SliderCard from '@/components/NewsHome';
import OfficeLocations from '@/components/OfficeLocations';
import { Reviews } from '@/components/Reviews';
import Seo from '@/components/seo/Seo';
import ServicesSection from '@/components/ServiceSection';
import ParallaxSlider from '@/components/slider/ParallaxSlider';
import StatsSection from '@/components/StatsSection';
import YoutubeSection from '@/components/YoutubeSection';

export default function Home() {
  return (
    <>
      <Seo
        title="Abdi Kerta Raharja | Koperasi Syariah Terpercaya"
        description="Koperasi Syariah Abdi Kerta Raharja melayani simpanan, pembiayaan, ZISWAF, dan pelatihan."
        canonical="https://www.abdikertaraharja.co.id/"
      />
      <ParallaxSlider />
      <StatsSection />
      <AboutSection />
      <ServicesSection />
      <YoutubeSection />
      <Reviews />
      <SliderCard />
      <LogoMitra />
      <OfficeLocations />
    </>
  );
}
